// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-page {
  display: flex;
  height: calc(100vh - 4rem);
  gap: 1.5rem;
  padding: 2rem;
}

.notes-sidebar {
  width: 300px;
  background: var(--white);
  border-radius: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-header {
  padding: 1.5rem;
  border-bottom: 1px solid var(--light-gray);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-header h2 {
  font-size: 1.5rem;
  color: var(--dark-gray);
  margin: 0;
}

.add-note-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: var(--white);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.categories {
  padding: 1rem;
  border-bottom: 1px solid var(--light-gray);
}

.category-btn {
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 0.5rem;
  text-align: left;
  color: var(--dark-gray);
}

.category-btn:hover {
  transform: translateX(5px);
}

.notes-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
}

.note-item {
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--background);
}

.note-item:hover {
  background: var(--light-gray);
}

.note-item.active {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(59, 130, 246, 0.1));
}

.note-item h4 {
  font-size: 1rem;
  color: var(--dark-gray);
  margin-bottom: 0.25rem;
}

.note-item p {
  font-size: 0.875rem;
  color: var(--medium-gray);
  margin-bottom: 0.5rem;
}

.note-date {
  font-size: 0.75rem;
  color: var(--medium-gray);
}

.notes-content {
  flex: 1 1;
  background: var(--white);
  border-radius: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.note-form-container,
.note-editor {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
}

.note-form {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.note-title-input,
.note-title-edit {
  font-size: 2rem;
  font-weight: 700;
  border: none;
  padding: 0.5rem;
  margin-bottom: 1rem;
  color: var(--dark-gray);
  background: transparent;
  border-bottom: 2px solid var(--light-gray);
}

.note-title-input:focus,
.note-title-edit:focus {
  outline: none;
  border-bottom-color: var(--primary-blue);
}

.note-category-select {
  padding: 0.5rem;
  margin-bottom: 1rem;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
  background: var(--white);
  color: var(--dark-gray);
  width: 200px;
}

.note-content-textarea,
.note-content-edit {
  flex: 1 1;
  padding: 1rem;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
  font-size: 1rem;
  line-height: 1.6;
  resize: none;
  font-family: inherit;
}

.note-content-textarea:focus,
.note-content-edit:focus {
  outline: none;
  border-color: var(--primary-blue);
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--light-gray);
}

.editor-header h2 {
  font-size: 2rem;
  color: var(--dark-gray);
  margin: 0;
}

.editor-actions {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
}

.edit-btn {
  background: rgba(59, 130, 246, 0.1);
  color: var(--primary-blue);
}

.edit-btn:hover {
  background: var(--primary-blue);
  color: var(--white);
}

.save-btn {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.save-btn:hover {
  background: #10b981;
  color: var(--white);
}

.cancel-btn {
  background: rgba(107, 114, 128, 0.1);
  color: var(--medium-gray);
}

.cancel-btn:hover {
  background: var(--medium-gray);
  color: var(--white);
}

.delete-btn {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.delete-btn:hover {
  background: #ef4444;
  color: var(--white);
}

.note-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.category-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 600;
}

.note-content {
  flex: 1 1;
  font-size: 1rem;
  line-height: 1.8;
  color: var(--dark-gray);
  white-space: pre-wrap;
  overflow-y: auto;
}

.empty-note {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--medium-gray);
}

.empty-note .empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-note h3 {
  font-size: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Notes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+EAA+E;EAC/E,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".notes-page {\n  display: flex;\n  height: calc(100vh - 4rem);\n  gap: 1.5rem;\n  padding: 2rem;\n}\n\n.notes-sidebar {\n  width: 300px;\n  background: var(--white);\n  border-radius: 1rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sidebar-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--light-gray);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sidebar-header h2 {\n  font-size: 1.5rem;\n  color: var(--dark-gray);\n  margin: 0;\n}\n\n.add-note-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n  color: var(--white);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.categories {\n  padding: 1rem;\n  border-bottom: 1px solid var(--light-gray);\n}\n\n.category-btn {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 0.5rem;\n  text-align: left;\n  color: var(--dark-gray);\n}\n\n.category-btn:hover {\n  transform: translateX(5px);\n}\n\n.notes-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n}\n\n.note-item {\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 0.75rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: var(--background);\n}\n\n.note-item:hover {\n  background: var(--light-gray);\n}\n\n.note-item.active {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(59, 130, 246, 0.1));\n}\n\n.note-item h4 {\n  font-size: 1rem;\n  color: var(--dark-gray);\n  margin-bottom: 0.25rem;\n}\n\n.note-item p {\n  font-size: 0.875rem;\n  color: var(--medium-gray);\n  margin-bottom: 0.5rem;\n}\n\n.note-date {\n  font-size: 0.75rem;\n  color: var(--medium-gray);\n}\n\n.notes-content {\n  flex: 1;\n  background: var(--white);\n  border-radius: 1rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.note-form-container,\n.note-editor {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n}\n\n.note-form {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.note-title-input,\n.note-title-edit {\n  font-size: 2rem;\n  font-weight: 700;\n  border: none;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  color: var(--dark-gray);\n  background: transparent;\n  border-bottom: 2px solid var(--light-gray);\n}\n\n.note-title-input:focus,\n.note-title-edit:focus {\n  outline: none;\n  border-bottom-color: var(--primary-blue);\n}\n\n.note-category-select {\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n  background: var(--white);\n  color: var(--dark-gray);\n  width: 200px;\n}\n\n.note-content-textarea,\n.note-content-edit {\n  flex: 1;\n  padding: 1rem;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  line-height: 1.6;\n  resize: none;\n  font-family: inherit;\n}\n\n.note-content-textarea:focus,\n.note-content-edit:focus {\n  outline: none;\n  border-color: var(--primary-blue);\n}\n\n.editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--light-gray);\n}\n\n.editor-header h2 {\n  font-size: 2rem;\n  color: var(--dark-gray);\n  margin: 0;\n}\n\n.editor-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.action-btn {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.2rem;\n}\n\n.edit-btn {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--primary-blue);\n}\n\n.edit-btn:hover {\n  background: var(--primary-blue);\n  color: var(--white);\n}\n\n.save-btn {\n  background: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n}\n\n.save-btn:hover {\n  background: #10b981;\n  color: var(--white);\n}\n\n.cancel-btn {\n  background: rgba(107, 114, 128, 0.1);\n  color: var(--medium-gray);\n}\n\n.cancel-btn:hover {\n  background: var(--medium-gray);\n  color: var(--white);\n}\n\n.delete-btn {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.delete-btn:hover {\n  background: #ef4444;\n  color: var(--white);\n}\n\n.note-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.category-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.note-content {\n  flex: 1;\n  font-size: 1rem;\n  line-height: 1.8;\n  color: var(--dark-gray);\n  white-space: pre-wrap;\n  overflow-y: auto;\n}\n\n.empty-note {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--medium-gray);\n}\n\n.empty-note .empty-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.empty-note h3 {\n  font-size: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
